import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { Image } from 'app/components';
import { NavLink, generatePath } from 'react-router-dom';

import { useConfig } from 'app/hooks';
import { FullwidthCarousel } from './styles';

const propTypes = {
  item: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired
};

const BoxSlider = ({ item }) => {
  // eslint-disable-next-line no-unused-vars
  const [_, i18n] = useTranslation();
  const { language } = i18n;
  const { routes } = useConfig();
  // const setDataStorage = () => {
  //   localStorage.setItem('competition', '1111');
  // };

  const languageContents = useMemo(
    () => ({
      title: language === 'en' ? 'title_en' : 'title',
      shortDescription: language === 'en' ? 'shortDescription_en' : 'shortDescription'
    }),
    [language]
  );

  const to = {
    pathname: generatePath(routes.eventDetails.pattern, {
      // id: item?.[languageContents.title].replaceAll(' ', '-')
      id: item?.eventurlname
    }),
    state: { eventId: item.id }
  };

  return (
    <>
      <FullwidthCarousel>
        <div className="box-slider">
          <NavLink to={to}>
            <div className="giftCardSlider">
              <Image src={item?.picture} className="cinema-rent__carousel-image" />
            </div>
            <div className="description_part">
              <h2>{item?.[languageContents.title]}</h2>
              <h3>{parse(item?.[languageContents.shortDescription])}</h3>
            </div>
          </NavLink>
        </div>
      </FullwidthCarousel>
    </>
  );
};

BoxSlider.propTypes = propTypes;

export default BoxSlider;
